export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAADCAYAAABS3WWCAAAAGElEQVQYV2O4evXqf4Znz579Z/j69et/AFCdCw6yX7NBAAAAAElFTkSuQmCC"